import { Component, Input  } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: '[s-input-tr]',
  templateUrl: './s-input-tr.component.html',
  imports: [TranslateModule]
})
export class SInputTrComponent  {
  @Input() label: string;

}
